import { ValueComponent } from "components/components/Component";
import { SimpleOutputBaseDefinition, SimpleOutputBaseComponent } from "components/output/baseOutputDefinition";
import template from "./time.hbs";
import "./time.scss";
import { TimeOutputElement, initTimeOutputWebComponent } from "./timeElement";

initTimeOutputWebComponent();

export class TimeOutput extends SimpleOutputBaseComponent<TimeOutputDefinition> implements ValueComponent {

    public readonly componentType: string = "timeOutput";

    private element: TimeOutputElement;

    constructor(schema: TimeOutputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        return this.view;
    }

    public renderTemplate(): Element {
        let objStyle: any = this.generateSytleAttribute();
        if (this.definition.labelKey == null) {
            objStyle.style = "max-width: 11ex;";
        }
        return super.renderTemplate(template, objStyle);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-time-output");

        this.genericBindEvents(this.element);
    }

    public getValue(): string {
        return this.element.data;
    }

    public value(v: string) {
        if ((v == null) || ((v as unknown) === "")) {
            this.element.data = null;
        } else {
            this.element.data = v;
        }
    }
}

export interface TimeOutputDefinition extends SimpleOutputBaseDefinition {
    seconds?: boolean;
    disableFinishedTyping?: boolean;
}
